import { createAsyncThunk } from '@reduxjs/toolkit';
import taskApi from '~/apis/task';
import {
  CREATE_FRANCHISE_TASK,
  CREATE_TASK,
  GET_FRANCHISE_TASK,
  GET_FRANCHISE_TASK_LIST,
  GET_TASK,
  GET_TASK_BOARD,
  GET_TASK_CUSTOMER_LIST,
  GET_TASK_FILE,
  GET_TASK_LIST,
  GET_TASK_SELECTION,
  UPDATE_FRANCHISE_TASK,
  UPDATE_TASK,
} from '~/utils/constants/actionType';
import {
  IEditTask,
  IFranchiseTask,
  IParamsGetTaskList,
  IResponseGetTaskBoard,
  IResponseGetTaskFiles,
  IResponseGetTaskList,
  IResponseTask,
  IResponseTaskSelectionList,
} from '~/utils/interface/task';

export const handleGetTaskSelection = createAsyncThunk<IResponseTaskSelectionList>(
  GET_TASK_SELECTION,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await taskApi.getSelection();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTask = createAsyncThunk<IResponseTask, string>(
  GET_TASK,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await taskApi.getTask(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFranchiseTask = createAsyncThunk<IFranchiseTask, string>(
  GET_FRANCHISE_TASK,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await taskApi.getFranchiseTask(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateTask = createAsyncThunk<null, { data: IEditTask }>(
  CREATE_TASK,
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.createTask(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateTaskCustomer = createAsyncThunk<null, { data: IEditTask }>(
  CREATE_TASK,
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.createTaskCustomer(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateTaskFranchise = createAsyncThunk<null, { data: IFranchiseTask }>(
  CREATE_FRANCHISE_TASK,
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.createFranchiseTask(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateTask = createAsyncThunk<null, { id: string | undefined; data: IEditTask }>(
  UPDATE_TASK,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.updateTask(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateTaskCustomer = createAsyncThunk<null, { id: string | undefined; data: IEditTask }>(
  UPDATE_TASK,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.updateTaskCustomer(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateFranchiseTask = createAsyncThunk<null, { id: string | undefined; data: IFranchiseTask }>(
  UPDATE_FRANCHISE_TASK,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.updateTaskFranchise(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTaskList = createAsyncThunk<
  IResponseGetTaskList,
  { taskId: string | undefined; data: IParamsGetTaskList }
>(GET_TASK_LIST, async ({ taskId, data }, { rejectWithValue }) => {
  try {
    const res = await taskApi.getTaskList(taskId, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetTaskListFranchise = createAsyncThunk<IResponseGetTaskList, { data: IParamsGetTaskList }>(
  GET_FRANCHISE_TASK_LIST,
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await taskApi.getFranchiseTaskList(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTaskOfCustomerList = createAsyncThunk<
  IResponseGetTaskList,
  { taskId: string | undefined; data: IParamsGetTaskList }
>(GET_TASK_CUSTOMER_LIST, async ({ taskId, data }, { rejectWithValue }) => {
  try {
    const res = await taskApi.getTaskOfCustomerList(taskId, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetTaskFiles = createAsyncThunk<IResponseGetTaskFiles, { id: string | undefined }>(
  GET_TASK_FILE,
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await taskApi.getFiles(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTaskBoard = createAsyncThunk<IResponseGetTaskBoard, { id: string; params: IParamsGetTaskList }>(
  GET_TASK_BOARD,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await taskApi.getTaskBoard(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
